// Lengths are typed in millimetres (a laser shows 2450 or 2450.5) and stored as integer
// micrometres. Parsing works on the decimal string, so no float ever touches a value.

const MM_RE = /^\s*(\d{1,6})(?:[.,](\d{1,3}))?\s*(?:мм|mm)?\s*$/i;

/** "2450" → 2450000, "2450.5" / "2450,5" → 2450500. null for anything that is not a length. */
export function parseMm(text: string): number | null {
  const m = MM_RE.exec(text);
  if (!m) return null;
  const whole = Number(m[1]);
  const frac = (m[2] ?? "").padEnd(3, "0");
  return whole * 1000 + Number(frac);
}

/** 2450000 → "2450", 2450500 → "2450.5", 2450250 → "2450.25". */
export function umToMmText(um: number): string {
  const sign = um < 0 ? "-" : "";
  const abs = Math.abs(Math.round(um));
  const whole = Math.trunc(abs / 1000);
  const frac = (abs % 1000).toString().padStart(3, "0").replace(/0+$/, "");
  return frac ? `${sign}${whole}.${frac}` : `${sign}${whole}`;
}

/** For labels: "2 450 мм" (grouped), with one decimal when it is not whole. */
export function formatMm(um: number): string {
  const tenths = Math.round(um / 100);
  const whole = Math.trunc(Math.abs(tenths) / 10);
  const rest = Math.abs(tenths) % 10;
  const sign = tenths < 0 ? "-" : "";
  const grouped = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${sign}${grouped}${rest ? `.${rest}` : ""} мм`;
}

/** A difference for checks: "1.4 мм". */
export function formatDelta(um: number): string {
  const tenths = Math.round(Math.abs(um) / 100);
  return `${Math.trunc(tenths / 10)}${tenths % 10 ? `.${tenths % 10}` : ""} мм`;
}
